module.exports = __webpack_public_path__ + "static/the-wine-of-wisdom-e35d542856aea0aff7255081d5896e79.jpg";